const funcion2 = {
    titulo: `Función: parámetros de tipo primitivo (number, string, boolean)`,
    problemas: [
      {
        codigo:1,
        descripcion: `Una función puede recibir datos a través de sus parámetros. Luego dentro del algoritmo de la función podemos acceder a esos datos.
La estructura de una función con parámetros es:
<code>
function [nombre de función](parametro1, parametro2, parametro3, y más) 
{ 
  [Algoritmo de la función] 
}
</code>
Cuando llamamos luego a la función le debemos pasar datos a dichos parámetros.`,
programa: `function sumar(x, y) {
  const suma = x + y
  console.log(suma)
}

sumar(2, 3)
`,
        solucion: "5"
      },{
        codigo:2,
        descripcion: `Los parámetros son datos que llegan a la función para que pueda cumplir su objeto.
En el ejemplo anterior pasamos directamente los valores, pero los datos pueden estar almacenados en variables.`,
programa: `function sumar(x, y) {
  let suma = x + y
  console.log(suma)
}

const valor1 = 10
const valor2 = 20
sumar(valor1, valor2)
`,
        solucion: "30"
      },{
        codigo:3,
        descripcion: `Los parámetros solo pueden ser accedidos dentro de la función. Si tratamos de acceder desde fuera, luego se genera un error.`,
programa: `function sumar(x, y) {
  let suma = x + y
}

console.log(x)

sumar(10,4)
`,
        solucion: "error"
      },{
        codigo:4,
        descripcion: `Algo sumamente importante cuando pasamos una variable numérica, string o boolean, es que se hace una copia del valor que se almacena en el parámetro. Luego si modificamos el valor del parámetro en la función, el valor de la variable que le pasamos no se modifica.
La variable definida fuera de la función y el parámetro pueden tener el mismo nombre.`,
programa: `function intentarCambiar(x) {
  x = 100
}

let x = 1
intentarCambiar(x)
console.log(x)
`,
        solucion: "1"
      },{
        codigo:5,
        descripcion: `Si cuando llamamos a una función no le pasamos el dato al parámetro, el mismo queda inicializado con el valor undefined.`,
programa: `function mostrar(titulo) {
  console.log(titulo)
}

mostrar()
`,
        solucion: "undefined"
      },{
        codigo:6,
        descripcion: `Los resultados de nuestro algoritmo puden ser impredecibles si no pasamos valores a los parámetros. Sumar dos valores undefined da un resultado NaN.`,
programa: `function sumar(valor1,valor2) {
  const suma=valor1+valor2
  console.log(suma)
}

sumar()
`,
        solucion: "NaN"
      },{
        codigo:`7`,
        descripcion: `Idéntico resultado se obtiene si pasamos solo uno de los parámetros`,
programa: `function sumar(valor1,valor2) {
  const suma=valor1+valor2
  console.log(suma)
}

sumar(10)
`,
        solucion: "NaN"
      },{
        codigo:`8`,
        descripcion: `Si sumamos un valor numérico y un string, el resultado es un string.`,
programa: `function sumar(valor1,valor2) {
  const suma=valor1+valor2
  console.log(suma)
}

sumar(10,'Hola')
`,
        solucion: "'10Hola'"
      },{
        codigo:`9`,
        descripcion: `En JavaScript si sumamos un valor numérico y el valor true, luego true se transforma en 1, en cambio false en 0.`,
programa: `function sumar(valor1,valor2) {
  const suma=valor1+valor2
  console.log(suma)
}

sumar(10,true)
`,
        solucion: "11"
      },{
        codigo:`10`,
        descripcion: ``,
programa: `function operar() {
  const op=true + true + false - true
  console.log(op)
}

operar()
`,
        solucion: "1"
      },{
        codigo:`11`,
        descripcion: ``,
programa: `function cantidadLetrasA(palabra) {
  let cant = 0
  for (let letra of palabra) {
    if (letra === 'a' || letra === 'A') {
      cant++
    }
  }
  console.log(cant)
}

cantidadLetrasA('Anana')`,
        solucion: "3"
      }
    ]
  }

export default funcion2;